
// export const logout = ( state ) => {
// }

export const setMunicipalities = (state, municipalities) => {
    state.municipalities = municipalities
}

export const setMunicipalitiesSelectable = (state, municipalities) => {
    state.municipalitiesSelectable = municipalities
}

export const setMunicipalitiesPaginated = (state, municipalitiesPaginatedData) => {
    state.municipalitiesPaginatedData = municipalitiesPaginatedData
}

export const setMunicipalityDetail = (state, municipality) => {
    state.municipality = municipality
}

export const saveNewMunicipalities = (state, municipality) => {
    state.municipalities.unshift(municipality)
    state.createdData = municipality;
}

export const saveUpdatedMunicipality = (state, municipality) => {
    state.municipalities.unshift(municipality)
    state.updatedData = municipality;
}

export const setDeleteMunicipality = (state, municipality) => {
    state.municipalitiesPaginatedData.data.filter(x => x.id !== municipality.id);
    state.deletedData = municipality
}

export const setMunicipalityIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setMunicipalityIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setMunicipalityIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setMunicipalityIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
